
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "21 exemples de landing page à suivre en 2026",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Ces pages uniques sont conçues avec un objectif précis : transformer de simples visiteurs en leads qualifiés, clients ou abonnés.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "21 exemples de landing page à suivre en 2026",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Ces pages uniques sont conçues avec un objectif précis : transformer de simples visiteurs en leads qualifiés, clients ou abonnés.",
        },
      ],
    };
  },
};
